/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import { buildApiUrl, makeAuthenticatedRequest } from '../config/api';

const parseJson = async (response) => {
  if (!response) {
    throw new Error('No response from server');
  }
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || 'Request failed');
  }
  return data?.data || data;
};

export const fetchPublicTestimonials = async () => {
  const response = await fetch(buildApiUrl('/api/public/testimonials'));
  if (!response.ok) {
    throw new Error('Unable to load testimonials');
  }
  const payload = await response.json();
  return payload?.data || [];
};

export const fetchAdminTestimonials = async () => {
  const response = await makeAuthenticatedRequest(
    buildApiUrl('/api/admin/testimonials')
  );
  return parseJson(response);
};

const buildFormData = (values) => {
  const formData = new FormData();
  formData.append('name', values.name || '');
  formData.append('headline', values.headline || '');
  formData.append('company', values.company || '');
  formData.append('quote', values.quote || '');
  formData.append('isVisible', values.isVisible ? 'true' : 'false');
  if (values.displayOrder) {
    formData.append('displayOrder', values.displayOrder);
  }
  if (values.photoFile instanceof File) {
    formData.append('photo', values.photoFile);
  }
  return formData;
};

export const createTestimonial = async (values) => {
  const response = await makeAuthenticatedRequest(
    buildApiUrl('/api/admin/testimonials'),
    {
      method: 'POST',
      body: buildFormData(values)
    }
  );
  return parseJson(response);
};

export const updateTestimonial = async (id, values) => {
  const response = await makeAuthenticatedRequest(
    buildApiUrl(`/api/admin/testimonials/${id}`),
    {
      method: 'PUT',
      body: buildFormData(values)
    }
  );
  return parseJson(response);
};

export const deleteTestimonial = async (id) => {
  const response = await makeAuthenticatedRequest(
    buildApiUrl(`/api/admin/testimonials/${id}`),
    { method: 'DELETE' }
  );
  await parseJson(response);
};

export const toggleTestimonialVisibility = async (id) => {
  const response = await makeAuthenticatedRequest(
    buildApiUrl(`/api/admin/testimonials/${id}/visibility`),
    { method: 'PATCH' }
  );
  return parseJson(response);
};


